import React, { useState, useEffect, useRef  } from 'react';
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
import { Link, Navigate, resolvePath } from "react-router-dom";
import {config} from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import { Button } from 'primereact/button';
import 'primeicons/primeicons.css';
import { Image } from "primereact/image";
import ShowError from "../shared/ShowError";
import ShowConfirm from "../shared/ShowConfirm";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Skeleton } from 'primereact/skeleton';
import { Toast } from 'primereact/toast';
import GeneralDialogFooter from '../shared/GeneralDialogFooter';
import SchoolCombo from "../combos/SchoolCombo";
import { Col, Form, Row } from 'react-bootstrap';
import FaDate from '../shared/FaDate';



export default function SchoolSetManager(props) {
  const toast = useRef(null);
  const [redirectUrl, setRedirectUrl] = useState("");
  const [errorVisible, setErorVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [saving, setSaving] = useState(false);
  const [loading, setLoading] = useState(true);

  const [school, setSchool] = useState({});
  const [nationalId, setNationalId] = useState("");
  const [mobile, setMobile] = useState("");
  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [birthDate, setBirthDate] = useState(0);
  const [oldBirthDate, setOldBirthDate] = useState(0);

  useEffect(() => {
  }, []);
  const checkDataEntry = function(){
    if(school == null){
          setErrorMessage("مدرسه را انتخاب نمائید");
          setErorVisible(true);
          return false;
    }
    if(!school.id){
          setErrorMessage("مدرسه را انتخاب نمائید");
          setErorVisible(true);
          return false;
    }
    if(school.id == ""){
          setErrorMessage("مدرسه را انتخاب نمائید");
          setErorVisible(true);
          return false;
    }
      if(firstname.trim().length == 0){
          setErrorMessage("نام مدیر را وارد کنید");
          setErorVisible(true);
          return false;
      }
      if(lastname.trim().length == 0){
          setErrorMessage("نام خانوادگی مدیر را وارد کنید");
          setErorVisible(true);
          return false;
      }
      if(nationalId.trim().length == 0){
          setErrorMessage("کد ملی کدیر را وارد کنید");
          setErorVisible(true);
          return false;
      }
      if(mobile.trim().length == 0){
          setErrorMessage("موبایل مدیر را وارد کنید");
          setErorVisible(true);
          return false;
      }
    return true;
  }

  const saveItem = function(){
    if(!checkDataEntry()) return;
    setSaving(true);
    var params = {login:util.getTrustedUser(), schoolId:school.id, nationalId:nationalId, mobile:mobile, firstname:firstname, lastname:lastname, birthDate:birthDate};
    var url = config.Server+`/user/school/by-admin/set-manager`;
    console.log("params---->", params)
    axios
        .post(url, params )
        .then(res => {
            var response = res.data;
            if(response.state === "ok"){
                response = response.data;
                setNationalId("");
                setMobile("");
                setFirstname("");
                setLastname("");
                setOldBirthDate(0);
                setBirthDate(0);
                setSaving(false);
                toast.current.show({ severity: 'info', summary: 'Info', detail: 'با موفقیت ثبت شد' });
            }
            else{
                setErrorMessage(response.message);
                setErorVisible(true);
                setSaving(false);
            }
        })
        .catch(error => {
            setErrorMessage(error.code + "," + error.message);
            setErorVisible(true);
            setSaving(false);
        });

  }
  const onComboChange = function(name, value){
    if(name == 'school'){
      setSchool(value);
      var id = "";
      if(value){
        if(value.id){
          id = value.id;
        }
      }
      var val = "";
      if(id == ""){
        setFirstname(val);
        setLastname(val);
        setNationalId(val);
        setMobile(val);
        setOldBirthDate(0);
        setBirthDate(0);
      }
      else{
        setLoading(true);
        setFirstname(val);
        setLastname(val);
        setNationalId(val);
        setMobile(val);
        setOldBirthDate(0);
        setBirthDate(0);
        var params = {login:util.getTrustedUser(), id:id};
        var url = config.Server+`/basic/school/get/id`;
        axios
            .post(url, params )
            .then(res => {
                var response = res.data;
                console.log(response);
                if(response.state === "ok"){
                    response = response.data;
                    console.log(response);
                    if(response != null){
                      if(response.manager != null){
                        setFirstname(response.manager.firstname);
                        setLastname(response.manager.lastname);
                        setNationalId(response.manager.nationalId);
                        setMobile(response.manager.mobile);
                        setOldBirthDate(response.manager.birthDate);
                        setBirthDate(response.manager.birthDate);

                      }
                    }
                    //setExpireDate({id:response.expireDate});
                    setLoading(false);
                }
                else{
                    setErrorMessage(response.message);
                    setErorVisible(true);
                    setLoading(false);
                }
            })
            .catch(error => {
                setErrorMessage(error.code + "," + error.message);
                setErorVisible(true);
                setLoading(false);
            });
      }
      
    }
  }
  const onInputChange = function(e, name){
      var val = '';
      val = (e.target && e.target.value) || '';
      if(name === "firstname") setFirstname(val);
      else if(name === "lastname") setLastname(val);
      else if(name === "nationalId") setNationalId(val);
      else if(name === "mobile") setMobile(val);
  }
  const setUsetActiveState = function(isActive){
    if(!checkDataEntry()) return;
    setSaving(true);
    var params = {login:util.getTrustedUser(), nationalId:nationalId, isActive:isActive};
    var url = config.Server+`/user/set/active-state`;
    axios
        .post(url, params )
        .then(res => {
            var response = res.data;
            if(response.state === "ok"){
                response = response.data;
                //setErrorMessage("با موفقیت ثبت شد");
                //setErorVisible(true);
                if(isActive){
                  toast.current.show({ severity: 'info', summary: 'Info', detail: 'با موفقیت ثبت شد' });
                }
                else{
                  toast.current.show({ severity: 'info', summary: 'Info', detail: 'با موفقیت ثبت شد' });
                }
                
                setSaving(false);
            }
            else{
                setErrorMessage(response.message);
                setErorVisible(true);
                setSaving(false);
            }
        })
        .catch(error => {
            setErrorMessage(error.code + "," + error.message);
            setErorVisible(true);
            setSaving(false);
        });

  }
  return(      
    <>
    <Row style={{marginTop:"20px"}} className='justify-content-center'>
      <Col md={3}>
        <div className="page-caption" style={{ width:"calc(100% - 0px)"}}>ثبت مدیر مدرسه</div>

        <Row style={{padding:"5px", marginTop:"15px"}}>
          <Col>
            <SchoolCombo returnFullItem={true} includeActive={true} includeInActive={false} value={school} onChange={(val) => onComboChange('school', val)} />
          </Col>
        </Row>
        {
          loading?
              <>              </>
              :
              <>
                <Row style={{padding:"5px", marginTop:"15px"}}>
                  <Col>
                    کد ملی
                    <br/>
                    <InputText value={nationalId} onChange={(e)=>{onInputChange(e, "nationalId")}} id="nationalId" keyfilter="int" maxLength={50} className="p-inputtext-lg" style={{width:"100%", textAlign:"center"}} />
                  </Col>
                </Row>
                <Row style={{padding:"5px", marginTop:"15px"}}>
                  <Col>
                    موبایل
                    <br/>
                    <InputText value={mobile} onChange={(e)=>{onInputChange(e, "mobile")}} id="mobile" keyfilter="int" maxLength={50} className="p-inputtext-lg" style={{width:"100%", textAlign:"center"}} />          
                  </Col>
                </Row>
                <Row style={{padding:"5px", marginTop:"15px"}}>
                  <Col>
                    نام
                    <br/>
                    <InputText value={firstname} onChange={(e)=>{onInputChange(e, "firstname")}} id="firstname" keyfilter="" maxLength={50} className="p-inputtext-lg" style={{width:"100%", textAlign:"center"}} />          
                  </Col>
                </Row>
                <Row style={{padding:"5px", marginTop:"15px"}}>
                  <Col>
                    نام خانوادگی
                    <br/>
                    <InputText value={lastname} onChange={(e)=>{onInputChange(e, "lastname")}} id="lastname" keyfilter="" maxLength={50} className="p-inputtext-lg" style={{width:"100%", textAlign:"center"}} />          
                  </Col>
                </Row>
                <Row style={{padding:"5px", marginTop:"15px"}}>
                  <Col>
                      تاریخ تولد:
                      <br/>
                      <FaDate value={oldBirthDate} onChange={(val)=>{setBirthDate(val);console.log("data is>", val)}} />
                  </Col>
                </Row>
                <Row style={{padding:"5px", marginTop:"15px"}}>
                  <Col md={6}>
                    <div className="card flex justify-content-center" style={{ direction: "ltr", textAlign:"right" }}>
                      <Button label="ثبت مدیر مدرسه" icon="pi pi-plus" onClick={()=>saveItem(true)} severity="success" iconPos="right" loading={saving} style={{}} />                  
                    </div>
                  </Col>
                </Row>
                <Row style={{padding:"5px", marginTop:"25px"}}><Col>تغیر وضعیت حساب کاربری مدیر مدرسه</Col></Row>
                <Row style={{padding:"5px", marginTop:"5px"}}>
                  <Col sd={6}>
                    <div className="card flex justify-content-center" style={{ direction: "ltr", textAlign:"right" }}>
                      <Button label="فعال شود" icon="pi pi-check" onClick={()=>setUsetActiveState(true)} severity="success" iconPos="right" loading={saving} />                  
                    </div>
                  </Col>
                  <Col sd={6}>
                    <div className="card flex justify-content-center" style={{ direction: "ltr", textAlign:"right" }}>
                      <Button label="غیر فعال شود" icon="pi pi-stop-circle" onClick={()=>setUsetActiveState(false)} severity="danger" iconPos="right" loading={saving} />                  
                    </div>
                  </Col>
                </Row>
                <Row style={{padding:"5px", marginTop:"15px"}}><Col>&nbsp;</Col></Row>
                <Row style={{padding:"5px", marginTop:"15px"}}><Col>&nbsp;</Col></Row>
                <Row style={{padding:"5px", marginTop:"15px"}}><Col>&nbsp;</Col></Row>
                <Row style={{padding:"5px", marginTop:"15px"}}><Col>&nbsp;</Col></Row>
              </>
        }
      </Col>
    </Row>   
        <ShowError visible={errorVisible} message={errorMessage} closeError={()=>{setErorVisible(false)}} />
          <Toast ref={toast} />
    </>  
  );
  
}
